import { Middleware } from "redux";

import { pushState } from "../../common/actions/Router";
import { isDirtySelector } from "../selectors";
import { RootState } from "../../state";
import i18n from "../../lib/i18n";

import { draftReset } from "../actions";

const draftChangesMiddleware: Middleware = ({ getState, dispatch }) => next => (action: any) => {
  if (pushState.match(action)) {
    const state = (getState() as any) as RootState;
    if (isDirtySelector(state)) {
      if (
        window.confirm(i18n.translate("company.draft_actions.warning_before_unload", { locale: state.auth.locale }))
      ) {
        dispatch(draftReset());
      } else {
        // Do not trigger router action
        return;
      }
    }
  }
  return next(action);
};

export default draftChangesMiddleware;



// WEBPACK FOOTER //
// ./frontend/src/companies/middlewares/draftChangesMiddleware.ts